import { StyledEngineProvider } from '@mui/material/styles';
import { Provider } from 'jotai';
import moment from 'moment';
import 'moment/locale/ja';
import 'normalize.css';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Router } from './components/Router';
import './config/initializeApp';

function Main() {
  moment.locale('ja');

  return (
    <Provider>
      <StyledEngineProvider injectFirst>
        <Router />
      </StyledEngineProvider>
    </Provider>
  );
}

const root = document.getElementById('app');

if (!root) {
  throw new Error('HTML Error');
}
createRoot(root).render(<Main />);
